module.exports = __webpack_public_path__ + "static/media/Crops.db84a69d.svg";